var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "#F0F6E6",
    stroke: "#688B2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2951 12.2623L14.5246 13.8361L14 16.9836L14.5246 23.2787L16.3607 25.9017L20.2951 28L23.7049 25.9017L25.541 23.8033L26.3279 20.9181V13.8361L20.2951 12.2623Z",
    fill: "#D7C3E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.521 15.528L21.1252 18.7447M26.521 18.3988L21.1252 21.6156M14.0144 13.4494L14 20.3704C14 23.2412 15.7294 25.8353 18.3581 26.9768L20.2951 27.9798L22.232 26.9768C24.8607 25.8353 26.5902 23.2412 26.5902 20.3358V13.4181L20.3297 12L14 13.4527L14.0144 13.4494Z",
    stroke: "#592375",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.0467ce2c4a8ff1cf07c1cfe71ada0924.svg";
export { ForwardRef as ReactComponent };